module.exports = __webpack_public_path__ + "5c88b187030bcb976d32b49e8d260d.png";